import { AppConfig } from '../app/helpers/config';
import { commonConfig, docsConfig } from './base';

export const environment: AppConfig = Object.assign({}, commonConfig, docsConfig, {
    apiUrl: 'https://kaptiodocs-cloudrun-mq2incz3ea-ew.a.run.app/',
    production: true,
});
